import React from 'react'
import Form from './components/formik'

const newTicket = () => {
    return (
        <Form/>
    )
}

export default newTicket
